import { fmtNum } from "../../lib/format";

export const SGK_GROUPS = [
  { key: "4a", title: "Hizmet Akdine Tabi Olanlar Açısından Prim Oranları (5510 Sayılı Kanunun 4/1 (a) Bendi Kapsamında Olanlar)", withTotal: true, discountKey: "indirim_5510",
    rows: [["myo", "Malüllük, Yaşlılık ve Ölüm"], ["gss", "Genel Sağlık Sigortası"], ["kvsk", "Kısa Vadeli Sigorta Kolları"], ["issizlik", "İşsizlik Sigortası"]] },
  { key: "fhs", title: "Fiili Hizmet Süresi Eklenecek İşlerde Çalışanlar İçin MYÖ Prim Oranı (Hizmet Akdine Tabii Çalışanlar İçin)",
    rows: [["fhs60", "60 Gün Eklenecek İşler"], ["fhs90", "90 Gün Eklenecek İşler"], ["fhs180", "180 Gün Eklenecek İşler"]] },
  { key: "sgdp", title: "Sosyal Güvenlik Destek Primi Oranı", extraLabel: "KVSK", rows: [["sgdp", "(4/a kapsamında çalışanlar için)"]] },
];
export const SGK_KEYS = [...SGK_GROUPS.flatMap((g) => g.rows.map((r) => r[0])), "indirim_5510"];

// "7,5" / "7.5" → 7.5 ; boş veya "-" → null ; geçersiz → NaN
export const parsePct = (s) => {
  const t = String(s ?? "").trim().replace(",", ".");
  if (t === "" || t === "-") return null;
  const n = parseFloat(t);
  return Number.isNaN(n) ? NaN : n;
};
export const pctStr = (v) => { const n = parsePct(v); return n == null || Number.isNaN(n) ? "-" : fmtNum(n, 2); };
const numStr = (v) => (v == null ? "" : String(v).replace(".", ","));
export const toFormRates = (rates) => Object.fromEntries(SGK_KEYS.map((k) => [k, { employer: numStr(rates?.[k]?.employer), employee: numStr(rates?.[k]?.employee), extra: numStr(rates?.[k]?.extra) }]));
export const toApiRates = (form) => Object.fromEntries(SGK_KEYS.map((k) => [k, { employer: parsePct(form[k]?.employer), employee: parsePct(form[k]?.employee), extra: parsePct(form[k]?.extra) }]));
export const rowTotal = (p) => {
  const vals = ["employer", "employee", "extra"].map((f) => parsePct(p?.[f])).filter((v) => v != null && !Number.isNaN(v));
  return vals.length ? vals.reduce((a, b) => a + b, 0) : null;
};
export const groupTotal = (form, keys) => {
  const sum = (f) => keys.reduce((a, k) => a + (parsePct(form[k]?.[f]) || 0), 0);
  return { employer: sum("employer") + sum("extra"), employee: sum("employee"), total: keys.reduce((a, k) => a + (rowTotal(form[k]) || 0), 0) };
};
export const EMPTY_PERIOD = { valid_from: "", valid_to: "", notes: "" };
